var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-simple-table',{staticClass:"mt-4"},[_c('tbody',[_c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.$t("NewEducators"))+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.educators)+" ")])]),_c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.$t("NewOrganizations"))+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.orgs)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }